import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  isOrderDetailPageLoading: true,
  orderDetailPageError: null,
  loading: false,
  requestingHardcopy: false,
  raisingDispute: false,
  error: null,
  details: null,
  sampleDetails: null,
  fetchingDropdown: false,
  downloadInProgress: false,
  dropdowns: {},
  checkForGRN: null,
  fetchCompanyFeatures: false,
  commodities: [],
  fetchingCommodities: false,
  states: [],
  fetchingStates: false,
  districts: [],
  fetchingDistricts: false,
  samplers: [],
  fetchingSamplers: false,
  updateOrderStatus: false,
  dropdowns: [],
  fetchingDropdown: false,
  projectCodes: [],
  fetchingProjectCodes: false,
  createReplacementOrder: false,
  newOrder: null,
  fetchingCompanies: false,
  companies: [],
  updateLabsAndLogistics: false,
  updateSampleDetails: false,
  isSubmittingCorrection: false,
  comments: [],
  commentsSuccess:false,
  logisticPartners: [],
  labs: [],
  sectors: [],
  labAnalytics: {},
  uploadingDocuments: false,
  removingDocument: null,
  documentError: null,
  orderCorrectionReasons: [],
  packages: [],
  agencies: [],
};

const orderDetailsSlice = createSlice({
  name: "orderDetails",
  initialState,
  reducers: {
    initializeError(state, action) {
      state.error = null;
    },
    fetchOrderDetails(state, action) {
      state.isOrderDetailPageLoading = true;
      state.orderDetailPageError = null;
    },
    fetchOrderDetailsSuccess(state, action) {
      state.details = action.payload.data.document;
      state.isOrderDetailPageLoading = false;
    },
    fetchOrderDetailsFailure(state, action) {
      state.isOrderDetailPageLoading = false;
      state.orderDetailPageError =
        action.payload?.message || "Failed to fetch order details";
    },
    clearOrderSpecificData(state) {
      state.details = null;
      state.sampleDetails = null;
      state.loading = true;
      state.labAnalytics = {};
    },
    createReplacementOrder(state, action) {
      state.createReplacementOrder = true;
    },
    createReplacementOrderSuccess(state, action) {
      state.createReplacementOrder = false;
      state.newOrder = action.payload?.newOrder?._id;
    },
    createReplacementOrderFailure(state, action) {
      state.createReplacementOrder = false;
      state.error = action.payload?.message || "";
    },
    updateLabsAndLogistics(state, action) {
      state.updateLabsAndLogistics = true;
    },
    updateLabsAndLogisticsSuccess(state, action) {
      state.updateLabsAndLogistics = false;
    },
    updateLabsAndLogisticsFailure(state, action) {
      state.updateLabsAndLogistics = false;
      state.error = action.payload.message;
    },
    fetchSampleDetails(state, action) {
      state.loading = true;
    },
    fetchSampleDetailsSuccess(state, action) {
      state.sampleDetails = action.payload.data;
      state.loading = false;
    },
    fetchSampleDetailsFailure(state, action) {
      state.loading = false;
    },
    fetchDropdown(state, action) {
      state.fetchingDropdown = true;
    },
    fetchDropdownSuccess(state, action) {
      state.fetchingDropdown = false;
      state.dropdowns = action.payload.data.document;
    },
    fetchDropdownFailure(state, action) {
      state.fetchingDropdown = false;
    },
    requestReportHardCopy(state, action) {
      state.requestingHardcopy = true;
    },
    requestReportHardCopySuccess(state, action) {
      state.requestingHardcopy = false;
    },
    requestReportHardCopyFailure(state, action) {
      state.requestingHardcopy = false;
      state.error = action.payload.message;
    },
    raiseDispute(state, action) {
      state.raisingDispute = true;
    },
    raiseDisputeSuccess(state, action) {
      state.raisingDispute = false;
    },
    raiseDisputeFailure(state, action) {
      state.raisingDispute = false;
      state.error = action.payload.message;
    },
    requestCorrection: (state, action) => {
      state.isSubmittingCorrection = true;
    },
    requestCorrectionSuccess: (state, action) => {
      state.isSubmittingCorrection = false;
    },
    requestCorrectionFailure: (state, action) => {
      state.isSubmittingCorrection = false;
      state.error = action.payload.message;
    },
    downloadFile(state, action) {
      state.downloadInProgress = true;
    },
    downloadFileSuccess(state, action) {
      state.downloadInProgress = false;
    },
    downloadFileFailure(state, action) {
      state.downloadInProgress = false;
    },
    addGRN(state, action) {
      state.addGRN = true;
    },
    addGRNSuccess(state, action) {
      state.addGRN = false;
    },
    addGRNFailure(state, action) {
      state.addGRN = false;
      state.error = action.payload.message;
    },
    updateGRNDetails(state, action) {
      state.updateGRNDetails = true;
    },
    updateGRNDetailsSuccess(state, action) {
      state.updateGRNDetails = false;
    },
    updateGRNDetailsFailure(state, action) {
      state.updateGRNDetails = false;
      state.error = action.payload.message;
    },
    updateOrderStatus(state, action) {
      state.updateOrderStatus = true;
    },
    updateOrderStatusSuccess(state, action) {
      state.updateOrderStatus = false;
    },
    updateOrderStatusFailure(state, action) {
      state.updateOrderStatus = false;
      state.error = action.payload.message;
    },

    fetchCompanyFeatures(state, action) {
      state.fetchCompanyFeatures = true;
    },
    fetchCompanyFeaturesSuccess(state, action) {
      state.fetchCompanyFeatures = false;
      state.checkForGRN = action.payload.data.document;
    },
    fetchCompanyFeaturesFailure(state, action) {
      state.fetchCompanyFeatures = false;
    },
    fetchCommodities(state, action) {
      state.fetchingCommodities = true;
    },
    fetchCommoditiesSuccess(state, action) {
      state.fetchingCommodities = false;
      state.commodities = action.payload.data.document;
    },
    fetchCommoditiesFailure(state, action) {
      state.fetchingCommodities = false;
    },
    fetchStates(state, action) {
      state.fetchingStates = true;
    },
    fetchStatesSuccess(state, action) {
      state.fetchingStates = false;
      state.states = action.payload.data.document;
    },
    fetchStatesFailure(state, action) {
      state.fetchingStates = false;
    },
    fetchDistricts(state, action) {
      state.fetchingDistricts = true;
    },
    fetchDistrictsSuccess(state, action) {
      state.fetchingDistricts = false;
      state.districts = action.payload.data.districts;
    },
    fetchDistrictsFailure(state, action) {
      state.fetchingDistricts = false;
    },
    fetchSamplers(state, action) {
      state.fetchingSamplers = true;
      state.samplers = [];
    },
    fetchSamplersSuccess(state, action) {
      state.fetchingSamplers = false;
      state.samplers = action.payload.data.sampler;
    },
    fetchSamplersFailure(state, action) {
      state.fetchingSamplers = false;
    },
    fetchProjectCodes(state, action) {
      state.fetchingProjectCodes = true;
      state.projectCodes = [];
    },
    fetchProjectCodesSuccess(state, action) {
      state.fetchingProjectCodes = false;
      state.projectCodes = action.payload.data;
    },
    fetchProjectCodesFailure(state, action) {
      state.fetchingProjectCodes = false;
    },
    fetchCompanies(state, action) {
      state.fetchingCompanies = true;
    },
    fetchCompaniesSuccess(state, action) {
      state.fetchingCompanies = false;
      state.companies = action.payload.data.document;
    },
    fetchCompaniesFailure(state, action) {
      state.fetchingCompanies = false;
    },
    updateSampleDetails(state, action) {
      state.updateSampleDetails = true;
    },
    updateSampleDetailsSuccess(state, action) {
      state.updateSampleDetails = false;
    },
    updateSampleDetailsFailure(state, action) {
      state.updateSampleDetails = false;
      // state.error = action.payload.message || "something went wrong";
    },
    fetchCommentsRequest(state) {
      state.commentsSuccess = false;
      state.error = null;
    },
    fetchCommentsSuccess(state, action) {
      state.commentsSuccess = true;
      state.comments = action.payload; // payload = array of comments
    },
    fetchCommentsFailure(state, action) {
      state.commentsSuccess = false;
      // state.error = action.payload?.message || "Failed to fetch comments";
    },
    initializeState(state, action) {
      state.loading = false;
      state.error = null;
      state.states = [];
      state.commodities = [];
      state.districts = [];
      state.samplers = [];
      state.projectCodes = [];
    },

    fetchLogisticPartners(state, action) {},
    fetchLogisticPartnersSuccess(state, action) {
      state.logisticPartners = action.payload.data.document;
    },
    fetchLogisticPartnersFailure(state, action) {},

    fetchLabs(state, action) {},
    fetchLabsSuccess(state, action) {
      state.labs = action.payload.data.document;
    },
    fetchLabsFailure(state, action) {},

    assignLabAndLogistic(state, action) {},
    assignLabAndLogisticSuccess(state, action) {},
    assignLabAndLogisticFailure(state, action) {},

    fetchSectors: (state, action) => {},
    fetchSectorsSuccess: (state, action) => {
      state.sectors = action.payload.data?.document;
    },
    fetchSectorsFailure: (state, action) => {},

    fetchLabAnalyticsDetails: (state, action) => {
      state.labAnalytics = {};
    },
    fetchLabAnalyticsDetailsSuccess: (state, action) => {
      state.labAnalytics = action.payload?.data?.document;
    },
    fetchLabAnalyticsDetailsFailure: (state, action) => {},

    updateOrderDocuments(state, action) {},
    updateOrderDocumentsSuccess(state, action) {
      state.details = {
        ...state.details,
        uploadedDocuments: action.payload.data.uploadedDocuments,
      };
    },
    updateOrderDocumentsFailure(state, action) {},

    requestOrderCorrection(state, action) {},
    requestOrderCorrectionSuccess(state, action) {},
    requestOrderCorrectionFailure(state, action) {},

    fetchOrderCorrectionReasons(state, action) {},
    fetchOrderCorrectionReasonsSuccess(state, action) {
      state.orderCorrectionReasons = action.payload.data.document;
    },
    fetchOrderCorrectionReasonsFailure(state, action) {},

    fetchPackages: (state, action) => {
      state.packages = [];
    },
    fetchPackagesSuccess: (state, action) => {
      state.packages = action.payload.data?.document;
    },
    fetchPackagesFailure: (state, action) => {},

    updateOrderDetails(state, action) {},
    updateOrderDetailsSuccess(state, action) {},
    updateOrderDetailsFailure(state, action) {},

    fetchAgencies: (state, action) => {},
    fetchAgenciesSuccess: (state, action) => {
      state.agencies = action.payload.data?.documents || [];
    },
    fetchAgenciesFailure: (state, action) => {},
  },
});

export const { actions, reducer, name: sliceKey } = orderDetailsSlice;
